import { AnalyticsEvent } from "./analyticsEvent";
import { ValidationError } from "@se/platform";
class NewsLetterValidationErrorEvent extends AnalyticsEvent {
    public readonly errorFields: string;
    constructor(validationErrors: ValidationError[]) {
        super();
        this.errorFields = validationErrors.map(ve => ve.fieldName).join(',').toLowerCase();
    }
}
export { NewsLetterValidationErrorEvent }